import React from 'react';
import Acknowledgement from 'src/models/leasing/Acknowledgement';
import AcknowledgementType from 'src/models/leasing/AcknowledgementType';
// import AcknowledgementComponent from './AcknowledgementComp'
import Card from 'src/components/common/Card.redesign';
import CardContainer from 'src/components/common/CardContainer.redesign';
import State from 'src/models/State';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';
// import acknowledgmentTypes from '../../../../../../src/models/AcknowledgmentTypeTest.json';
// Card hover styles
import '../../../../common/styles/hover-highlight.scss';
import { ContextMenuAction } from 'src/components/common/ContextMenu';

interface IAcknowledgementListProps {
    acknowledgements?: Acknowledgement[];
    acknowledgementType?: AcknowledgementType[];
    states?: State[];
    invoiceableLookupId?: number;
    isNewLease?: boolean;
    olderVersions?: boolean;
    refreshLease?: (data: boolean) => void;
    hideDialog?: () => void;
}

const AcknowledgementList = (props: IAcknowledgementListProps) => {
    const dialogContext = React.useContext<dialogCreators>(DialogContext);

    const acknowledgementCard = () => {
        return props?.acknowledgements?.length > 0 ? (
            props.acknowledgements.map((ack, index) => {
                const actions: ContextMenuAction[] = !!props.isNewLease
                    ? [{ text: 'Actions Disabled', action: () => console.log('Not Allowed') }]
                    : [
                          {
                              text: 'Edit Acknowledgment',
                              action: () =>
                                  dialogContext.project.addEditAcknowledgementRTE(
                                      ack,
                                      props.acknowledgementType,
                                      false,
                                      props?.refreshLease,
                                      props?.invoiceableLookupId,
                                  ),
                          },
                          {
                              text: 'Delete Acknowledgment',
                              action: () => dialogContext.project.addDeleteAcknowledgement(ack, props.hideDialog, props?.refreshLease),
                          },
                      ];

                const ackType = props.acknowledgementType.find(at => at.id === ack.typeId);

                return (
                    <React.Fragment key={index}>
                        <Card style={{ margin: '1rem' }} contextActions={actions} newContext={true} showMenu={true}>
                            <div style={{ display: 'flex', justifyContent: 'space-evenly', alignContent: 'center', marginBottom: '1rem' }}>
                                <span>Template: {ackType?.name ?? 'No type selected'}</span>
                            </div>
                        </Card>
                    </React.Fragment>
                );
            })
        ) : (
            <Card>
                <div style={{ textAlign: 'center' }}>
                    <p>No Acknowledgment Created!</p>
                </div>
            </Card>
        );
    };

    const handleNewAcknowledgement = () => {
        dialogContext.project.addEditAcknowledgementRTE(
            {},
            props.acknowledgementType,
            true,
            props?.refreshLease,
            props?.invoiceableLookupId,
        );
    };

    return (
        <>
            <CardContainer style={{ backgroundColor: 'white', maxHeight: '50vh', padding: '1rem', overflow: 'auto' }}>
                {acknowledgementCard()}
            </CardContainer>
            <div style={{ marginTop: '2rem' }}>
                <Button text="Add Acknowledgment" intent="primary" onClick={handleNewAcknowledgement} disabled={props.isNewLease} />
            </div>
        </>
    );
};

export default AcknowledgementList;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/AcknowledgementList.tsx